<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-66 md-small-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>contacts</md-icon>
          </div>
          <h4 class="title">Adicionar Usuário</h4>
        </md-card-header>

        <form @submit.prevent="add">
          <md-card-content>
            <div class="text-right">
              <md-button @click="goBack" class="md-primary md-dense">
                Voltar
              </md-button>
            </div>

            <div class="md-layout spacing">
              <label class="md-layout-item md-size-25 md-form-label">
                Foto
              </label>
              <div class="md-layout-item">
                <div class="file-input">
                  <div v-if="image">
                    <div class="image-container">
                      <img :src="image" />
                    </div>
                  </div>
                  <div class="image-container" v-else>
                    <img :src="default_img" />
                  </div>
                  <div class="button-container">
                    <md-button
                      class="md-danger md-round"
                      @click="removeImage"
                      v-if="image"
                    >
                      <i class="fa fa-times" />
                      Remover
                    </md-button>
                    <md-button class="md-success md-fileinput">
                      <template v-if="!image">Selecionar Imagem</template>
                      <template v-else>Alterar</template>
                      <input type="file" @change="onFileChange" />
                    </md-button>
                  </div>
                </div>
                <md-field class="md-invalid">
                  <validation-error :errors="apiValidationErrors.attachment" />
                </md-field>
              </div>
            </div>

            <div class="md-layout spacing">
              <label class="md-layout-item md-size-25 md-form-label">
                Nome
              </label>
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="user.name" />
                  <validation-error :errors="apiValidationErrors.name" />
                </md-field>
              </div>
            </div>

            <div class="md-layout spacing">
              <label class="md-layout-item md-size-25 md-form-label">
                Usuário
              </label>
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="user.username" />
                  <validation-error :errors="apiValidationErrors.username" />
                </md-field>
              </div>
            </div>

            <div class="md-layout spacing">
              <label class="md-layout-item md-size-25 md-form-label">
                E-mail
              </label>
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="user.email" />
                  <validation-error :errors="apiValidationErrors.email" />
                </md-field>
              </div>
            </div>

            <div class="md-layout spacing">
              <label class="md-layout-item md-size-25 md-form-label">
                Perfil
              </label>
              <div class="md-layout-item">
                <md-field>
                  <label>Selecione...</label>
                  <md-select
                    v-if="user.roles"
                    v-model="user.roles[0].id"
                    name="roles"
                  >
                    <md-option
                      v-for="item in available_roles"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
            </div>

            <div class="md-layout spacing">
              <label class="md-layout-item md-size-25 md-form-label">
                Senha
              </label>
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input v-model="user.password" type="password" />
                  <validation-error :errors="apiValidationErrors.password" />
                </md-field>
              </div>
            </div>

            <div class="md-layout">
              <label class="md-layout-item md-size-25 md-form-label">
                Confirmar Senha
              </label>
              <div class="md-layout-item">
                <md-field class="md-invalid">
                  <md-input
                    v-model="user.password_confirmation"
                    type="password"
                  />
                  <validation-error
                    :errors="apiValidationErrors.password_confirmation"
                  />
                </md-field>
              </div>
            </div>
          </md-card-content>

          <md-card-actions md-alignment="right">
            <md-button type="submit" class="md-success">Adicionar</md-button>
          </md-card-actions>
        </form>
      </md-card>
    </div>
  </div>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
  components: { ValidationError },

  mixins: [formMixin],

  data: () => ({
    user: {
      type: "users",
      name: null,
      username: null,
      email: null,
      password: null,
      password_confirmation: null,
      roles: [
        {
          id: null,
          type: "roles",
        },
      ],
      relationshipNames: ["roles"],
    },

    available_roles: [],

    image: "",
    default_img: process.env.VUE_APP_BASE_URL + "/img/placeholder.jpg",
    file: null,
  }),

  created() {
    this.getRoles();
  },

  methods: {
    async add() {
      try {
        this.resetApiValidation();
        delete this.user.id;

        await this.$store.dispatch("users/add", this.user);
        this.user = await this.$store.getters["users/user"];

        if (!!this.file) {
          // upload image and get image url
          await this.$store.dispatch("users/upload", {
            user: this.user,
            image: this.file,
          });
          this.user.profile_image = await this.$store.getters["users/url"];
          // update user with image url
          await this.$store.dispatch("users/update", this.user);
          this.user = await this.$store.getters["users/user"];
        }

        await this.$store.dispatch(
          "alerts/success",
          "User added successfully."
        );

        this.goBack();
      } catch (e) {
        if (e.response.data.errors[0]) {
          await this.$store.dispatch(
            "alerts/error",
            e.response.data.errors[0].title
          );
          this.setApiValidation(e.response.data.errors);
        } else {
          await this.$store.dispatch(
            "alerts/error",
            "Oops, something went wrong!"
          );
          this.setApiValidation(e.response.data.errors);
        }
        if (this.user.id) {
          await this.$store.dispatch("users/destroy", this.user.id);
        }
      }
    },

    getRoles() {
      this.$store.dispatch("roles/list").then(() => {
        this.available_roles = this.$store.getters["roles/dropdown"];
      });
    },

    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },

    createImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.image = e.target.result;
        this.file = file;
      };
      reader.readAsDataURL(file);
    },

    removeImage() {
      this.image = null;
    },

    goBack() {
      this.$router.push({ name: "List Users" });
    },
  },
};
</script>

<style lang="scss">
.spacing {
  padding-bottom: 1rem;
}
</style>
